import type { Warranty } from '@econtractor/types';
import * as apiWarranties from 'api/apiWarranties';
import { getObjectRecord } from '../../OffKeys/keysUtils';

const PAGE_SIZE = 100;
const MAX_PAGES = 20;

/** Active warranties assigned to the document's object, in product-name order. */
export const loadObjectWarranties = async (objectData: unknown): Promise<Warranty[]> => {
    const objectId = Number(getObjectRecord(objectData)?.ID || 0);
    if (!Number.isSafeInteger(objectId) || objectId <= 0) return [];

    const rows: Warranty[] = [];
    let page = 1;
    let countPages = 1;
    while (page <= countPages && page <= MAX_PAGES) {
        const result = await apiWarranties.list(
            { page, onPage: PAGE_SIZE, order: 'prodName', desc: false },
            objectId,
        );
        rows.push(...(result.warranties || []));
        countPages = Math.max(1, Number(result.paginator?.countPages || 1));
        page += 1;
    }
    return rows;
};
